// extracted by mini-css-extract-plugin
export var button = "styles-module--button--2a37a";
export var compact = "styles-module--compact--b25eb";
export var katacodaIcon = "styles-module--katacodaIcon--c66ae";